import { Navigate, useRoutes } from 'react-router-dom';
// layouts
import MainLayout from 'src/layouts/main';
// config
// import { PATH_AFTER_LOGIN } from 'src/config-global';
//
import PrivacyPolicyPage from 'src/pages/privacy-policy/page';
import TermsOfConditionsPage from 'src/pages/terms-and-conditions/page';
import { admindashboardRoutes } from './admin-dashboard';
import { authRoutes } from './auth';
import { authDemoRoutes } from './auth-demo';
import { componentsRoutes } from './components';
import { dashboardRoutes } from './dashboard';
import { HomePage, mainRoutes } from './main';
import { superadmindashboardRoutes } from './superadmin-dashboard';
import LoginPage from 'src/sections/auth/jwt/login-page';



// ----------------------------------------------------------------------

export default function Router() {


  return useRoutes([
    // SET INDEX PAGE WITH SKIP HOME PAGE
    // {
    //   path: '/',
    //   element: <Navigate to={PATH_AFTER_LOGIN} replace />,
    // },

    // ----------------------------------------------------------------------

    // SET INDEX PAGE WITH HOME PAGE
    {
      path: '/',
      element: (
        // <MainLayout>
        //   <HomePage />
        // </MainLayout>
        <LoginPage />
      ),
    },
    {
      path: "/privacy-policy",
      element: <MainLayout>
        <PrivacyPolicyPage />
      </MainLayout>
    },
    {
      path: "/terms-and-conditions",
      element: <MainLayout>
        <TermsOfConditionsPage />
      </MainLayout>
    },

    // Auth routes
    ...authRoutes,
    ...authDemoRoutes,
    //  Dashboard routes
    ...dashboardRoutes,


    //super-admin dashboard
    ...superadmindashboardRoutes,

    //user-dashboard
    ...admindashboardRoutes,

    // Main routes
    ...mainRoutes,

    // Components routes
    ...componentsRoutes,



    // No match 404
    { path: '*', element: <Navigate to="/" replace /> },
  ]);
}
